<template>
  <div>
    <h2>Do you have children?</h2>
    <p>If you are currently expecting a child, select No</p>
    <ValidationObserver ref="observer">
      <v-form @submit.prevent="submit">
        <ValidationProvider
          id="children"
          v-slot="{ errors }"
          name="children"
          rules="required"
        >
          <RadioSelect
            v-model="hasChildren"
            :items="[
              { value: true, text: 'Yes' },
              { value: false, text: 'No' },
            ]"
            :errors="errors"
            :group="'children'"
          />
        </ValidationProvider>
        <div class="button-container">
          <DefaultButton
            @defaultButtonClicked="redirectBack"
            :small="true"
            :callout="'left'"
          />
          <GradientButton
            :title="'Next'"
            :small="true"
            :callout="'right'"
            :type="'submit'"
            :loading="buttonLoading"
          />
        </div>
      </v-form>
    </ValidationObserver>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import { UPDATE_TESTATOR_MUTATION } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'DoYouHaveChildren',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: { type: Object, required: true },
    },
    data() {
      return {
        hasChildren: this.testator.hasChildren,
        wizard: this.$route.query.peopleWizard,
      };
    },
    methods: {
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.hasChildren ? this.redirectToNext() : this.updateTestator();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      updateTestator() {
        const testatorInputDetails = {
          hasChildren: this.hasChildren,
        };
        const id = this.testator.id;
        this.$apollo
          .mutate({
            mutation: UPDATE_TESTATOR_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
          })
          .then(_response => {
            this.redirectToNext();
            this.buttonLoading = false;
            if (!this.wizard) this.$emit('refetchQuery');
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      redirectToNext() {
        if (this.hasChildren) {
          this.$router.push('add-children');
        } else {
          if (this.wizard == 'children') {
            this.$router.push({ name: 'PeopleOverview', hash: '#children' });
          } else {
            this.$router.push('emergency-contacts');
          }
        }
      },
      redirectBack() {
        if (this.wizard == 'children') {
          this.$router.push({ name: 'PeopleOverview', hash: '#children' });
        } else if (this.testator.isMarried) {
          this.$router.push('spouse');
        } else {
          this.$router.push('married');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    margin-top: 40px;
    display: flex;
    gap: 20px;
  }
</style>
